import { CircleCheck,Circle,CircleAlert,Flag,X } from 'lucide-react';

export default function EncountersTag({type}:{type:string}){
    const tagStyles = {
        "Closed": "text-[#00C781] bg-[#E6FAF2]",
        "action_needed": "text-[#FFA726] bg-[#FFF5E6]", 
        "in_progress": "text-[#4272DD] bg-[#4272DD1A]",
        "red_flagged": "text-[#FF3B3B] bg-[#FFEBEB]",
        "treatment_completed": "text-[#6E23C9] bg-[#6E23C91A]",
        "completed":  "text-[#00C781] bg-[#E6FAF2]",
        "missed": "text-[#7F8493] bg-[#7F849326]"
    }[type] || "";

    return (
        <span className={`${tagStyles} text-[14px] w-fit leading-[140%] font-medium flex items-center gap-[2px] py-[2px] px-[5px] rounded-full tracking-[-1%]`}>
            {type === "Closed" && <CircleCheck className="size-4" />}
            {type === "action_needed" && <CircleAlert className="size-4" />}
            {type === "in_progress" && <Circle className="size-4" />}
            {type === "red_flagged" && <Flag className="size-4" />}
            {type === "treatment_completed" && <CircleCheck className="size-4" />}
            {type === "completed" && <CircleCheck className="size-4" />}
            {type === "missed" && <X className="size-4" />}
            {type?.charAt(0).toUpperCase() + type?.slice(1).replace(/_/g, ' ')}
        </span>
    )
}
